import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { EventNames, EVENTS } from '@app/constants/events.constants';
import { AuthService, UserService } from '@app/shared/services';
import { select, Store } from '@ngrx/store';
//
import { fromEvent, Observable, Subscription } from 'rxjs';
import * as loginSelectors from '../../../../root-store/login-store/login.selector';
import { SetupItemCardNavService } from '../../../../shared/services/setup-item-card-nav/setup-item-card-nav.service';
import { loginStoreActions, RootStoreState } from '@app/root-store';
import * as selectors from '../../../../root-store/vault-store/vault.selector';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import { getCurrentUserDetailsAll } from '../../../../root-store/login-store/login.selector';
import { ChatWidgetService } from '@app/shared/services/chat-widget/chat-widget.service';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MyResponsibilitiesComponent } from '../my-responsibilities/my-responsibilities.component';
import { InstructionComponent } from '../components/instruction-component/instruction.component';
import { ButtonSlideComponent } from '../../button-slide/button-slide.component';
@AutoUnsubscribe()
@Component({
    selector: 'network-responsibilities',
    templateUrl: './network-responsibilities.component.html',
    styleUrl: './network-responsibilities.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule,
      MatTooltipModule,
      MatDividerModule,
      MatProgressSpinnerModule,
      InstructionComponent,
      ButtonSlideComponent,
      MyResponsibilitiesComponent
    ]
})
export class NetworkResponsibilitiesComponent implements OnInit, OnDestroy {
  @Input() accountType;
  @ViewChild('sidenav') public sidenav: MatSidenav;
  @Output() closeOnboardingSideBarEventEmitter = new EventEmitter();
  private setupItemCardNavService = inject(SetupItemCardNavService);
  private userService = inject(UserService);
  user$;
  showLoader = false;
  screenWidth: number;
  switchFromUser = false;
  subscription: Subscription = new Subscription();

  steps = [
    { title: 'instructions', completed: false, status: 'inactive' },
    { title: 'My Responsibilities', completed: false, status: 'inactive', subText: '', listHeader: '' },
    { title: 'Status', completed: false, status: 'inactive', subText: '', listHeader: '' },
  ];

  @Input() isImpersonating = false;
  resizeObservable$: Observable<Event>;
  currentActiveIndex = 0;
  currentActiveElement;
  currentUser;
  markAsComplete = false;
  setupInstructions = [];
  filteredUserVaults = [];
  filteredSuggestedVaults = [];
  vaultItems: any[];
  guardianList: any[] | null = null;
  constructor(
    private _userService: UserService,
    private store: Store,
    private cd: ChangeDetectorRef,
    private sharedVaultService: SharedVaultService,
    private store$: Store<RootStoreState.State>,
    private chatWidgetService: ChatWidgetService,
    private authService: AuthService
  ) {
    this.subscription.add(
      this.store.pipe(select(selectors.getVaultOnboardItems('Last Updated'))).subscribe((item) => {
        this.vaultItems = [item];
        this.cd.detectChanges();
      })
    );
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe(async (result) => {
        try {
          if (result) {
            this.isImpersonating = true;
          }
          const authUser = this.authService.user;
          if (result?.switch_from_user_id && result?.id != authUser['id']) {
            this.isImpersonating = true;
          } else {
            this.isImpersonating = false;
          }
          this.cd.detectChanges();
        } catch (ex) {}
      })
    );
    this.user$ = this.store.select(getCurrentUserDetailsAll);
    this.subscription.add(
      this.user$.subscribe((user) => {
        this.currentUser = user;
        this.cd.detectChanges();
      })
    );
    this.setupInstructions = [
      {
        title: 'About Guardian Vaults Setup',
        list: [
          `The first step of the onboarding process is to start building the network for Kate.`,
          'By doing this first, when we start organizing data, we can easily assign permissions, share, delegate tasks and plug people in as role players appropriately.',
        ],
      },
      {
        title: 'A few points to keep in mind:',
        list: [
          `Each user is in complete control of who they connect to, and how data is shared with others.`,
          `Just being connected to someone doesn't automatically give them access to anything. `,
          `Users can add or remove people from their network at any point in the future.`,
        ],
      },
    ];
    this.getGuardianUsers(this.vaultItems[0]);
  }
  ngAfterViewInit() {
    this.steps[0].completed = false;
    this.setStatusForSidenavMenu(0);
    this.trackEventsInMixPanel([{ eventName: EVENTS.network_setup_instruction_start }]);
  }

  closeSideNav() {
    this.setupItemCardNavService.handleNav(false, 'onboarding_responsibility_complete');
    // this.cd.detectChanges();
    this.closeOnboardingSideBarEventEmitter.emit(false);
  }

  ngOnDestroy(): void {
    this.markAsComplete = false;
    this.subscription?.unsubscribe();
    this._userService.cleanupWorker();
  }
  handleSidenavMenuNavigation(index?: number) {
    if (!!index || index == 0) {
      this.setStatusForSidenavMenu(index);
    } else {
      this.setStatusForSidenavMenu();
    }
  }

  trackEventsInMixPanel(events: { eventName: EventNames; data?: any }[]) {
    this._userService.trackEventsInMixPanel(events).then((response) => {});
  }

  setStatusForSidenavMenu(activeIndex?: number) {
    if (activeIndex === undefined) {
      // Move to the next step
      if (this.currentActiveIndex !== undefined && this.currentActiveIndex < this.steps.length - 1) {
        activeIndex = this.currentActiveIndex + 1;
      } else {
        // If no more steps are available, do nothing or reset to the first step
        activeIndex = 0; // or handle this case based on your requirements
      }
    }

    if (activeIndex !== -1 && activeIndex < this.steps.length) {
      for (let i = 0; i < this.steps.length; i++) {
        if (i === activeIndex) {
          this.steps[i].status = 'active';
          this.currentActiveElement = this.steps[i];
        } else {
          this.steps[i].status = 'inactive';
        }
      }
      this.markAsComplete = false;
      this.currentActiveIndex = activeIndex;
      this.cd.detectChanges();
    }

    if (this.currentActiveIndex == 1) {
      this.trackEventsInMixPanel([
        { eventName: EVENTS.network_responsibilities_end },
        { eventName: EVENTS.network_responsibilities_myrespons_start },
      ]);
    } else if (this.currentActiveIndex == 2) {
      this.trackEventsInMixPanel([{ eventName: EVENTS.network_responsibilities_status_complete }]);
    }
  }
  submitAllFormAnswers(value) {
    this.markAsComplete = !!value;
    if (!!value) {
      this.completeSetup();
    }
  }
  gotoPrevious() {
    if (this.currentActiveIndex > 0) {
      this.currentActiveIndex = this.currentActiveIndex - 1;

      for (let i = 0; i < this.steps.length; i++) {
        if (i === this.currentActiveIndex) {
          this.steps[i].status = 'active';
          this.currentActiveElement = this.steps[i];
        } else {
          this.steps[i].status = 'inactive';
        }
      }
      this.cd.detectChanges();
    }
  }
  handleaddUserDetails(userId: string) {
    const userToMove = this.filteredSuggestedVaults.find((user) => user.user_id === userId);
    const vaultUserIds = this.vaultItems[0].map((vault) => vault.user_id);
    if (userToMove) {
      this.filteredSuggestedVaults = this.filteredSuggestedVaults.filter((user) => user.user_id !== userId && !vaultUserIds.includes(user.user_id));
      this.filteredUserVaults = [...this.filteredUserVaults, userToMove];
    }

    this.cd.detectChanges();
  }
  handleDeleteUserDetails(userId: string) {
    const userToMove = this.filteredUserVaults.find((user) => user.user_id === userId);
    this.subscription.add(
      this.sharedVaultService.getVaults(this.currentUser.id).subscribe(
        async (vaults) => {
          const vaultmemberItems = vaults.filter((vault) => vault.type?.toLowerCase() === 'personal' && vault.is_system === true);
          await this.getGuardianUsers(vaultmemberItems);
          this.cd.detectChanges();
        },
        (error) => {
          console.error('Error fetching vaults:', error);
        }
      )
    );
    // const vaultUserIds = this.vaultItems[0].map((vault) => vault.user_id);
    // if (userToMove) {
    //   this.filteredUserVaults = this.filteredUserVaults.filter(
    //     (user) => (user.user_id !== userId) && vaultUserIds.includes(user.user_id)
    //   );
    //   this.filteredSuggestedVaults = [...this.filteredSuggestedVaults, userToMove];
    // }

    this.cd.detectChanges();
  }

  completeSetup() {
    this.subscription.add(
      this.userService
        .updateCompleteOnboardingResponsibility({
          onboarding_responsibility_complete: this.markAsComplete,
          user_id: this.currentUser.id,
        })
        .subscribe(() => {
          this.store.dispatch(new loginStoreActions.LoginRequestAction());
          this.closeSideNav();
        })
    );
  }
  handleCreateUserDetails(event) {
    this.subscription.add(
      this.sharedVaultService.createPersonalVaultMember({ user_id: event.user_id }).subscribe(
        async (data) => {
          this.subscription.add(
            this.sharedVaultService.getVaults(this.currentUser.id).subscribe(
              async (vaults) => {
                const vaultmemberItems = vaults.filter((vault) => vault.type?.toLowerCase() === 'personal' && vault.is_system === true);
                await this.getGuardianUsers(vaultmemberItems);
                this.cd.detectChanges();
              },
              (error) => {
                console.error('Error fetching vaults:', error);
              }
            )
          );
        },
        (error) => {
          console.error('Error creating user:', error);
        }
      )
    );
  }
  getGuardianUsers(vaultItems) {
    this.subscription.add(
      this.userService.getGuardianUsers().subscribe((users) => {
        this.guardianList = users;
        const vaultUserIds = vaultItems.map((vault) => vault.user_id);
        this.filteredUserVaults = this.guardianList.filter((guardian) => vaultUserIds.includes(guardian.user_id));
        this.filteredSuggestedVaults = this.guardianList.filter((guardian) => !vaultUserIds.includes(guardian.user_id));
        this.cd.detectChanges();
      })
    );
  }
}
